export default function ErrorSection(props) {
    const {
        error,
        handleFetchCities
    } = props
    
    return (
        <div className="errorSection">
            <span className="errorMessage">{error}</span>
            <button className="btnBgBlueTextGradient" onClick={handleFetchCities}>Try again</button>
        </div>
    )
}
